export default {
  lang: {
    en: 'English',
    de: 'Deutsch',
    fr: 'Français',
  },

  nav: {
    home: 'Accueil',
    services: 'Services',
    about: 'À propos',
    contact: 'Contact',
    quote: 'Demander un devis',
  },

  footer: {
    tagline:
      "Services professionnels de nettoyage et de facility management pour les particuliers et les entreprises. Nous entretenons vos espaces avec soin et précision.",
    quickLinks: 'Liens rapides',
    ourServices: 'Nos services',
    contactInfo: 'Contact',
    address: "Rte de Rosé 51, 1754 Avry-sur-Matran, Suisse",
    privacy: 'Politique de confidentialité',
    terms: "Conditions d'utilisation",
    rights: 'Tous droits réservés.',
    services: [
      'Nettoyage professionnel',
      "Entretien d'immeubles",
      'Services de conciergerie',
      'Entretien des espaces extérieurs',
      'Nettoyage spécialisé',
      'Facility Management',
    ],
  },

  hero: {
    badge: 'Plus de 5 000 clients satisfaits dans toute la Suisse',
    titleLine1: 'Un espace propre est un',
    titleLine2: 'espace heureux',
    subtitle:
      "Limpia Sàrl propose des services de nettoyage professionnels et écologiques pour les particuliers et les entreprises. Vivez la joie d'un environnement impeccable et frais — à chaque fois.",
    ctaQuote: 'Obtenez votre devis gratuit',
    ctaServices: 'Découvrir nos services',
    scroll: 'Faites défiler pour explorer',
  },

  servicesOverview: {
    badge: 'Notre offre',
    title: 'Services de nettoyage professionnels',
    subtitle:
      "De l'entretien quotidien au nettoyage en profondeur, nous proposons une gamme complète de solutions de nettoyage adaptées à vos besoins.",
    items: [
      {
        icon: 'ri-sparkling-2-line',
        title: 'Nettoyage professionnel',
        description: 'Un nettoyage soigné et régulier pour des espaces propres, sains et agréables au quotidien.',
        features: ['Nettoyage de bureaux', "Nettoyage d'immeubles", 'Régulier ou ponctuel'],
      },
      {
        icon: 'ri-building-line',
        title: "Entretien d'immeubles",
        description: "L'entretien quotidien de vos immeubles pour préserver leur propreté, leur confort et leur qualité.",
        features: ['Parties communes', 'Escaliers et couloirs', 'Buanderies'],
      },
      {
        icon: 'ri-user-heart-line',
        title: 'Services de conciergerie',
        description: "Un service de proximité pour le bon fonctionnement et l'entretien courant de vos immeubles.",
        features: ['Contrôle des parties communes', 'Gestion des déchets', "Petits travaux d'entretien"],
      },
      {
        icon: 'ri-plant-line',
        title: 'Entretien des espaces extérieurs',
        description: 'Nous maintenons vos espaces extérieurs propres, entretenus et accueillants tout au long de l’année.',
        features: ['Entretien des espaces verts', 'Tonte des pelouses', 'Taille des haies'],
      },
      {
        icon: 'ri-brush-line',
        title: 'Nettoyage spécialisé',
        description: "Des interventions pour les situations nécessitant une attention particulière et un nettoyage en profondeur.",
        features: ['Nettoyage après travaux', 'Nettoyage après déménagement', 'Nettoyage en profondeur'],
      },
      {
        icon: 'ri-dashboard-line',
        title: 'Facility Management',
        description: "La coordination professionnelle des prestations d'entretien pour vos bâtiments.",
        features: ['Coordination des interventions', 'Suivi des prestations', "Planification de l'entretien"],
      },
    ],
  },

  stats: {
    labels: ["Années d'expérience", 'Clients servis', 'Personnel professionnel', 'Taux de satisfaction'],
  },

  why: {
    badge: 'Pourquoi choisir Limpia',
    titleLine1: 'Des espaces propres,',
    titleLine2: 'des visages heureux',
    subtitle:
      "Nous ne sommes pas une simple entreprise de nettoyage. Nous sommes votre partenaire pour créer un environnement plus sain et plus agréable — chez vous comme au travail.",
    rating: 'Note moyenne',
    items: [
      {
        icon: 'ri-leaf-line',
        title: 'Produits écologiques',
        description: 'Nous utilisons des solutions de nettoyage biodégradables et non toxiques, sûres pour votre famille, vos animaux et la planète.',
      },
      {
        icon: 'ri-shield-check-line',
        title: 'Assurés & garantis',
        description: "Une couverture d'assurance complète et un personnel certifié vous apportent une tranquillité d'esprit totale.",
      },
      {
        icon: 'ri-user-star-line',
        title: 'Professionnels formés',
        description: "Chaque membre de l'équipe suit une formation rigoureuse et une vérification avant d'intervenir chez vous.",
      },
      {
        icon: 'ri-thumb-up-line',
        title: 'Satisfaction garantie',
        description: "Pas satisfait ? Nous revenons et corrigeons le tir — sans question, sans frais supplémentaires.",
      },
      {
        icon: 'ri-calendar-check-line',
        title: 'Planification flexible',
        description: 'Réservez chaque semaine, toutes les deux semaines, chaque mois ou ponctuellement. Matin, après-midi ou soir — nous nous adaptons.',
      },
      {
        icon: 'ri-money-euro-circle-line',
        title: 'Prix compétitifs',
        description: 'Des prix transparents et clairs, sans frais cachés. Une qualité de nettoyage adaptée à votre budget.',
      },
    ],
  },

  testimonials: {
    badge: 'Témoignages',
    title: 'Ce que disent nos clients',
    subtitle: 'De vrais retours de personnes qui nous confient leurs espaces.',
    items: [
      {
        name: 'Sophie Lambert',
        role: 'Propriétaire',
        content:
          "Limpia nettoie mon appartement depuis plus de deux ans. L'équipe est toujours ponctuelle, incroyablement minutieuse, et les produits écologiques me rassurent avec mes deux jeunes enfants à la maison.",
      },
      {
        name: 'Marc Dubois',
        role: 'Responsable de bureau',
        content:
          "Nous sommes passés à Limpia pour le nettoyage de nos bureaux il y a six mois et la différence est frappante. Nos locaux n'ont jamais été aussi beaux, et l'équipe est professionnelle et discrète. Je recommande vivement.",
      },
      {
        name: 'Claire Muller',
        role: 'Gérante immobilière',
        content:
          "En tant que gérante de plusieurs immeubles, j'ai besoin d'un partenaire de nettoyage fiable. Limpia assure à chaque fois — fiable, constant, avec un souci du détail remarquable.",
      },
      {
        name: 'Thomas Weber',
        role: 'Restaurateur',
        content:
          "La propreté est essentielle dans la restauration. Limpia réalise nos nettoyages en profondeur avec précision et soin. Ils comprennent nos exigences et les dépassent toujours.",
      },
    ],
  },

  quote: {
    badge: 'Commencer',
    title: 'Prêt pour un espace plus propre ?',
    subtitle:
      "Parlez-nous de vos besoins et nous vous répondrons avec un devis personnalisé sous 24 heures. Sans engagement, sans pression — juste un espace impeccable.",
    points: ['Devis gratuit et sans engagement', 'Réponse sous 24 heures', 'Adapté à vos besoins'],
    form: {
      name: 'Nom complet',
      namePlaceholder: 'Votre nom complet',
      email: 'Adresse e-mail',
      emailPlaceholder: 'vous@exemple.com',
      phone: 'Numéro de téléphone',
      phonePlaceholder: '+41 ...',
      service: 'Type de service',
      servicePlaceholder: 'Sélectionnez un service...',
      serviceOptions: [
        'Nettoyage professionnel',
        "Entretien d'immeubles",
        'Services de conciergerie',
        'Entretien des espaces extérieurs',
        'Nettoyage spécialisé',
        'Facility Management',
      ],
      message: 'Parlez-nous de vos besoins',
      messagePlaceholder: 'Décrivez votre espace, vos horaires préférés et toute exigence particulière...',
      submit: 'Demander votre devis gratuit',
    },
    success: {
      title: 'Merci !',
      message: 'Merci ! Nous vous répondrons sous 24 heures.',
    },
    error: {
      title: 'Oups !',
      tryAgain: 'Réessayer',
      network: 'Erreur réseau. Veuillez réessayer plus tard.',
    },
  },

  servicesPage: {
    header: {
      badge: 'NOS SERVICES',
      title: 'Des solutions professionnelles pour vos bâtiments et vos espaces',
      description:
        "Limpia Sàrl vous accompagne avec des services de nettoyage, d'entretien et de conciergerie adaptés aux besoins des particuliers, entreprises, propriétaires et régies immobilières.",
    },
    learnMore: 'En savoir plus',
    items: [
      {
        title: 'Nettoyage professionnel',
        description: 'Un nettoyage soigné et régulier pour garantir des espaces propres, sains et agréables au quotidien.',
        imageAlt: 'Nettoyage professionnel de bureaux par Limpia Sàrl',
        features: [
          'Nettoyage de bureaux',
          "Nettoyage d'immeubles",
          'Nettoyage de surfaces commerciales',
          'Nettoyage régulier ou ponctuel',
        ],
      },
      {
        title: "Entretien d'immeubles",
        description: "Nous assurons l'entretien quotidien de vos immeubles afin de préserver leur propreté, leur confort et leur qualité.",
        imageAlt: "Entretien d'immeubles — parties communes par Limpia Sàrl",
        features: [
          'Parties communes',
          'Escaliers et couloirs',
          'Sous-sols et locaux communs',
          'Buanderies',
          'Garages et parkings',
        ],
      },
      {
        title: 'Services de conciergerie',
        description: "Un service de proximité pour assurer le bon fonctionnement et l'entretien courant de vos immeubles.",
        imageAlt: 'Services de conciergerie par Limpia Sàrl',
        features: [
          'Contrôle des parties communes',
          'Gestion des déchets',
          "Petits travaux d'entretien",
          "Suivi des besoins de l'immeuble",
          'Signalement des éventuels problèmes',
        ],
      },
      {
        title: 'Entretien des espaces extérieurs',
        description: 'Nous veillons à maintenir vos espaces extérieurs propres, entretenus et accueillants tout au long de l’année.',
        imageAlt: 'Entretien des espaces extérieurs par Limpia Sàrl',
        features: [
          'Entretien des espaces verts',
          'Tonte des pelouses',
          'Taille des haies',
          'Nettoyage des espaces extérieurs',
        ],
      },
      {
        title: 'Nettoyage spécialisé',
        description: "Des interventions adaptées aux situations qui nécessitent une attention particulière et un nettoyage en profondeur.",
        imageAlt: 'Nettoyage spécialisé après travaux par Limpia Sàrl',
        features: [
          'Nettoyage après travaux',
          'Nettoyage après déménagement',
          'Nettoyage en profondeur',
          'Interventions ponctuelles',
        ],
      },
      {
        title: 'Facility Management',
        description: "Une coordination professionnelle des prestations d'entretien pour simplifier la gestion quotidienne de vos bâtiments.",
        imageAlt: 'Facility Management par Limpia Sàrl',
        features: [
          'Coordination des interventions',
          'Suivi des prestations',
          "Planification de l'entretien",
          'Solutions adaptées aux propriétaires et régies',
        ],
      },
    ],
    cta: {
      title: "Besoin d'une solution adaptée à votre bâtiment ?",
      text: "Parlons de vos besoins et trouvons ensemble une solution d'entretien adaptée à votre situation.",
      button: 'Demander un devis',
      secondary: 'Nous contacter',
    },
  },

  about: {
    badge: 'Qui sommes-nous',
    title: 'À propos de Limpia Sàrl',
    subtitle:
      'Une entreprise de proximité, dédiée à l’entretien et à la propreté de vos bâtiments et espaces.',
    imageAlt: 'Entretien de bâtiments par Limpia Sàrl',
    section: {
      headline: 'Une entreprise de proximité, au service de vos bâtiments',
      paragraph1:
        'Limpia Sàrl accompagne les propriétaires, régies immobilières, entreprises et copropriétés dans l’entretien et la propreté de leurs bâtiments et espaces.',
      paragraph2:
        'Notre objectif est simple : offrir un service fiable, soigné et adapté aux besoins de chaque client. Du nettoyage régulier à l’entretien des immeubles et des espaces extérieurs, nous proposons des solutions flexibles pour garantir des environnements propres, entretenus et agréables au quotidien.',
      paragraph3:
        'À l’écoute de nos clients, nous privilégions la qualité du travail, la proximité et un suivi attentif de chaque prestation.',
      highlights: [
        { icon: 'ri-shield-check-line', title: 'Fiabilité' },
        { icon: 'ri-award-line', title: 'Qualité' },
        { icon: 'ri-hand-heart-line', title: 'Proximité' },
      ],
      cta: 'En savoir plus',
    },
  },

  contactPage: {
    badge: 'CONTACT',
    title: 'Contactez Limpia Sàrl',
    subtitle:
      "Une question ou besoin d'une solution pour votre bâtiment ? Notre équipe est à votre disposition.",
    phone: 'Téléphone',
    email: 'E-mail',
    address: 'Adresse',
    mapTitle: 'Nous trouver',
  },
};